import { ETag } from '../../types/feedbackFormSettings';
export var HELP_LINKS = [{
  tag: ETag.A,
  link: 'https://hc.cian.ru/hc/ru/articles/4411927379604?utm_source=fos&utm_medium=organic&utm_campaign=traffic_from_fos',
  text: 'Как войти в нужный аккаунт?'
}, {
  tag: ETag.A,
  link: 'https://hc.cian.ru/hc/ru/articles/360035415631?utm_source=fos&utm_medium=organic&utm_campaign=traffic_from_fos',
  text: 'Как бесплатно разместить объявление?'
}, {
  tag: ETag.A,
  link: 'https://hc.cian.ru/hc/ru/articles/360037896052?utm_source=fos&utm_medium=organic&utm_campaign=traffic_from_fos',
  text: 'Как правильно ввести адрес?'
}];
export var DEFAULT_LINK_MODEL = {
  model: {
    header: 'Или попробуйте найти ответ сами — так будет быстрее',
    elements: HELP_LINKS
  }
};
export var DEFAULT_ERROR_MESSAGE = 'Что-то пошло не так, попробуйте ещё раз';